import { useCallback, useState } from 'react'
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import LoadingSpinner from '../../../../../components/LoadingSpinner/LoadingSpinner'
import SearchInput from '../../../../../components/SearchInput'
import { useLoading } from '../../../../../hooks/LoadingContext'
import DashboardLayout from '../../../../../layouts/Dashboard/index'
import api from '../../../../../services/api'
import { errorApi } from '../../../../../utils/errorApi'

import styles from './styles.module.css'

const EntregasProblemasNovo: React.FC = () => {
  const navigate = useNavigate()
  const { isLoading, setIsLoading } = useLoading()

  const [requestDeliveryDriverNote, setRequestDeliveryDriverNote] = useState<string>('')
  const [deliveryProblemSolution, setDeliveryProblemSolution] = useState<string>('')

  const [requests, setRequests] = useState<any[]>()
  const [requestId, setRequestId] = useState<number>()

  const [showRequests, setShowRequests] = useState<boolean>(false)

  const isValidModel = () => {
    if (!requestId || !requestDeliveryDriverNote.length) return false
    return true
  }

  const loadRequestsData = useCallback(
    async (search: string) => {
      setIsLoading(true)
      try {
        let { data } = await api.get(`/delivery-manager/requests/delivery?status=allocated,on_route,delivered,canceled&search=${search}`)

        data = data.map((request: any) => {
          let requestIdentifier = request.invoice_number
            ? `NF nº ${request.invoice_number}`
            : request.request_number
              ? `Pedido nº ${request.request_number}`
              : `NFe nº ${request.invoice.substring(0, 10)}...`

          return {
            ...request,
            name: `${requestIdentifier} | ${request.receiver_name} ${request.id}`,
          }
        })
        setRequests(data)
      } catch (err) {
        toast.error('Falha ao buscar os dados das requisições! Atualize a página.')
      }
      setIsLoading(false)
    },
    [setIsLoading],
  )

  const handleRequestClearInput = () => {
    setShowRequests(false)
  }

  const handleRequestSearch = (search: string) => {
    loadRequestsData(search)
    setShowRequests(true)
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault()

    setIsLoading(true)

    try {
      await api.put(`/delivery-manager/requests/${requestId}`, {
        request_delivery_driver_note: requestDeliveryDriverNote,
        delivery_problem_solution_note: deliveryProblemSolution,
        delivery_had_problems: true,
      })

      toast.info('O problema ocorrido foi cadastrado com sucesso!', { autoClose: 3000 })
      setIsLoading(false)
      navigate('/gestor-entregas/entregas/problemas')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao cadastrar o problema ocorrido! Verifique os dados.'))
      setIsLoading(false)
    }
  }

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Cadastrar problema">
      <LoadingSpinner text="Sincronizando informações. Aguarde..." />
      <Container>
        <h2 style={{ textAlign: 'center' }}>Novo problema ocorrido</h2>
        <Col className={styles.formContainer}>
          <Row style={{ marginTop: 15 }}>
            <Form.Label className={styles.label}>
              Selecione o pedido onde o problema ocorreu*
            </Form.Label>
            <SearchInput
              data={requests as never[]}
              showOptions={showRequests}
              setValue={(value: number) => setRequestId(value)}
              handleClear={handleRequestClearInput}
              handleSearch={handleRequestSearch}
              placeholder="Pesquise o nome do cliente, nº do pedido/nota, código fiscal, placa do veículo ou nome do motorista"
              edit={false}
            />
          </Row>

          <Row style={{ marginTop: 0, textAlign: 'left' }}>
            <Col style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Descrição do problema*</Form.Label>
              <Form.Control
                className={styles.input}
                style={{
                  resize: 'none',
                  fontSize: 14,
                }}
                as="textarea"
                rows={3}
                placeholder="Descreva o problema ocorrido"
                value={requestDeliveryDriverNote}
                onChange={(event) => setRequestDeliveryDriverNote(event.target.value)}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 15, textAlign: 'left' }}>
            <Col>
              <Form.Label className={styles.label}>Solução do problema</Form.Label>
              <Form.Control
                className={styles.input}
                style={{
                  resize: 'none',
                }}
                as="textarea"
                rows={3}
                placeholder="Descreva a solução para o problema ocorrido"
                value={deliveryProblemSolution}
                onChange={(event) => setDeliveryProblemSolution(event.target.value)}
              />
            </Col>
          </Row>
          <Col style={{ marginTop: 15, textAlign: 'right' }}>
            <Button
              className={styles.btn_submit}
              disabled={isLoading || !isValidModel()}
              onClick={handleSubmit}
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    color: '#fff',
                    marginRight: 10,
                  }}
                />
              ) : (
                'Cadastrar problema'
              )}
            </Button>
          </Col>
        </Col>
      </Container>
    </DashboardLayout>
  )
}

export default EntregasProblemasNovo
